import { useGoogleMapsAutoComplete } from '../../../providers/googleMaps/useGoogleMapsAutoComplete';
import { useGoogleMapsGeocodeHandler } from '../../../providers/googleMaps/useGoogleMapsGeocodeHandler';
import { useAtlasHandler } from '../../../providers/useAtlasHandler';
import { IAddressInputProps } from '../AddressInput.types';

export const useProviderInfo = ({
  provider,
  googleMapsApiKey,
  lang,
  country,
  translateFn,
  getPlace,
  predict,
  onSuggestionsUpdate,
}: Pick<
  IAddressInputProps,
  | 'provider'
  | 'googleMapsApiKey'
  | 'lang'
  | 'country'
  | 'getPlace'
  | 'predict'
  | 'onSuggestionsUpdate'
> & {
  translateFn: (key: string, fallbackValue: string) => string;
}) => {
  const {
    autoComplete: googleAutoComplete,
    autocompleteError: googleAutocompleteError,
  } = useGoogleMapsAutoComplete(
    googleMapsApiKey,
    lang,
    country,
    translateFn,
    onSuggestionsUpdate,
  );
  const { getGeocode: googleGetGeocode } = useGoogleMapsGeocodeHandler(
    googleMapsApiKey,
    lang,
    country,
  );

  const {
    autoComplete: atlasAutoComplete,
    autocompleteError: atlasAutocompleteError,
    getGeocode: atlasGetGeocode,
  } = useAtlasHandler({
    country,
    getPlace,
    predict,
    translate: translateFn,
    onSuggestionsUpdate,
  });

  if (provider === 'googleMaps') {
    return {
      autoComplete: googleAutoComplete,
      autocompleteError: googleAutocompleteError,
      getGeocode: googleGetGeocode,
    };
  } else {
    return {
      autoComplete: atlasAutoComplete,
      autocompleteError: atlasAutocompleteError,
      getGeocode: atlasGetGeocode,
    };
  }
};
